import _classCallCheck from "/codebuild/output/src187591491/src/vkiptvlco/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/codebuild/output/src187591491/src/vkiptvlco/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/codebuild/output/src187591491/src/vkiptvlco/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/codebuild/output/src187591491/src/vkiptvlco/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/codebuild/output/src187591491/src/vkiptvlco/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import defaultProps from '../default-props';
import mappings from '../illustrations/mappings';
var Undraw = /*#__PURE__*/function (_Component) {
  _inherits(Undraw, _Component);
  function Undraw() {
    _classCallCheck(this, Undraw);
    return _possibleConstructorReturn(this, _getPrototypeOf(Undraw).apply(this, arguments));
  }
  _createClass(Undraw, [{
    key: "render",
    /**
     * Render.
     */
    value: function render() {
      var _this$props = this.props,
        name = _this$props.name,
        rest = _objectWithoutProperties(_this$props, ["name"]);
      var Illustration = mappings[name];
      if (!Illustration) {
        return null;
      }
      return React.createElement(Illustration, rest);
    }
  }], [{
    key: "setDefaultProps",
    /**
     * Default props.
     */
    /**
     * Prop types.
     */
    /**
     * Override default prop values.
     *
     * @param {Object} props Properties to set as default values.
     */
    value: function setDefaultProps(props) {
      if (!props) {
        return;
      }
      Object.assign(defaultProps, props);
    }
  }]);
  return Undraw;
}(Component);
export { Undraw as default };
_defineProperty(Undraw, "defaultProps", {
  height: defaultProps.height,
  primaryColor: defaultProps.primaryColor
});
_defineProperty(Undraw, "propTypes", {
  name: PropTypes.string.isRequired,
  height: PropTypes.string,
  primaryColor: PropTypes.string
});